(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/helpers/objectSpread'), require('redux'), require('lodash.isnil'), require('lodash.flowright'), require('react-redux'), require('@babel/runtime/helpers/classCallCheck'), require('@babel/runtime/helpers/createClass'), require('@babel/runtime/helpers/possibleConstructorReturn'), require('@babel/runtime/helpers/getPrototypeOf'), require('@babel/runtime/helpers/inherits'), require('react'), require('prop-types'), require('react-is'), require('@babel/runtime/helpers/defineProperty'), require('lodash.omit'), require('react-fast-compare'), require('lodash.intersection'), require('lodash.camelcase'), require('deepmerge'), require('create-react-context')) :
  typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/helpers/objectSpread', 'redux', 'lodash.isnil', 'lodash.flowright', 'react-redux', '@babel/runtime/helpers/classCallCheck', '@babel/runtime/helpers/createClass', '@babel/runtime/helpers/possibleConstructorReturn', '@babel/runtime/helpers/getPrototypeOf', '@babel/runtime/helpers/inherits', 'react', 'prop-types', 'react-is', '@babel/runtime/helpers/defineProperty', 'lodash.omit', 'react-fast-compare', 'lodash.intersection', 'lodash.camelcase', 'deepmerge', 'create-react-context'], factory) :
  (global = global || self, factory(global['@flopflip/react-redux'] = {}, global._objectSpread, global.redux, global.isNil, global.flowRight, global['react-redux'], global._classCallCheck, global._createClass, global._possibleConstructorReturn, global._getPrototypeOf, global._inherits, global.React, global.PropTypes, global.reactIs, global._defineProperty, global.omit, null, global.intersection, global.camelCase, global.merge, global.createReactContext));
}(this, function (exports, _objectSpread, redux, isNil, flowRight, reactRedux, _classCallCheck, _createClass, _possibleConstructorReturn, _getPrototypeOf, _inherits, React, PropTypes, reactIs, _defineProperty, omit, reactFastCompare, intersection, camelCase, merge, createReactContext) { 'use strict';

  _objectSpread = _objectSpread && _objectSpread.hasOwnProperty('default') ? _objectSpread['default'] : _objectSpread;
  isNil = isNil && isNil.hasOwnProperty('default') ? isNil['default'] : isNil;
  flowRight = flowRight && flowRight.hasOwnProperty('default') ? flowRight['default'] : flowRight;
  _classCallCheck = _classCallCheck && _classCallCheck.hasOwnProperty('default') ? _classCallCheck['default'] : _classCallCheck;
  _createClass = _createClass && _createClass.hasOwnProperty('default') ? _createClass['default'] : _createClass;
  _possibleConstructorReturn = _possibleConstructorReturn && _possibleConstructorReturn.hasOwnProperty('default') ? _possibleConstructorReturn['default'] : _possibleConstructorReturn;
  _getPrototypeOf = _getPrototypeOf && _getPrototypeOf.hasOwnProperty('default') ? _getPrototypeOf['default'] : _getPrototypeOf;
  _inherits = _inherits && _inherits.hasOwnProperty('default') ? _inherits['default'] : _inherits;
  var React__default = 'default' in React ? React['default'] : React;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
  _defineProperty = _defineProperty && _defineProperty.hasOwnProperty('default') ? _defineProperty['default'] : _defineProperty;
  omit = omit && omit.hasOwnProperty('default') ? omit['default'] : omit;
  intersection = intersection && intersection.hasOwnProperty('default') ? intersection['default'] : intersection;
  camelCase = camelCase && camelCase.hasOwnProperty('default') ? camelCase['default'] : camelCase;
  merge = merge && merge.hasOwnProperty('default') ? merge['default'] : merge;
  createReactContext = createReactContext && createReactContext.hasOwnProperty('default') ? createReactContext['default'] : createReactContext;

  var UPDATE_FLAGS = '@flopflip/flags/update';
  var initialState = {}; // Reducer

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case UPDATE_FLAGS:
        return _objectSpread({}, state, action.payload);

      default:
        return state;
    }
  };
  var createReducer = function createReducer() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return reducer(state, action);
    };
  }; // Action Creators

  var updateFlags = function updateFlags(flags) {
    return {
      type: UPDATE_FLAGS,
      payload: flags
    };
  }; // Selectors

  var selectFlags = function selectFlags(state) {
    return state[STATE_SLICE].flags;
  };
  var selectFlag = function selectFlag(flagName) {
    return function (state) {
      var allFlags = selectFlags(state);
      var flagValue = allFlags[flagName];
      return isNil(flagValue) ? false : flagValue;
    };
  };

  // Actions
  var UPDATE_STATUS = '@flopflip/status/update';
  var initialState$1 = {
    isReady: false
  }; // Reducer

  var reducer$1 = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
      case UPDATE_STATUS:
        return _objectSpread({}, state, {
          isReady: action.payload.isReady
        });

      default:
        return state;
    }
  };

  var updateStatus = function updateStatus(status) {
    return {
      type: UPDATE_STATUS,
      payload: status
    };
  };

  var flopflipReducer = redux.combineReducers({
    flags: reducer,
    status: reducer$1
  });
  var createFlopflipReducer = function createFlopflipReducer() {
    var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return redux.combineReducers({
      flags: createReducer(preloadedState),
      status: reducer$1
    });
  };

  function createFlopFlipEnhancer(adapter, adapterArgs) {
    return function (next) {
      return function () {
        var store = next.apply(void 0, arguments);
        adapter.configure(_objectSpread({}, adapterArgs, {
          /**
           * NOTE: This is like `bindActionCreators` but the bound action
           * creators are renamed to fit the adapter API and conventions.
           */
          onFlagsStateChange: function onFlagsStateChange() {
            return store.dispatch(updateFlags.apply(void 0, arguments));
          },
          onStatusStateChange: function onStatusStateChange() {
            return store.dispatch(updateStatus.apply(void 0, arguments));
          }
        }));
        return store;
      };
    };
  }

  var STATE_SLICE = '@flopflip';

  function warning(condition, message) {
    {
      if (condition) {
        return;
      }

      var text = "Warning: " + message;

      if (typeof console !== 'undefined') {
        console.warn(text);
      }

      try {
        throw Error(text);
      } catch (x) {}
    }
  }

  var isEmptyChildren = function isEmptyChildren(children) {
    return React__default.Children.count(children) === 0;
  };

  var ToggleFeature =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ToggleFeature, _PureComponent);

    function ToggleFeature() {
      _classCallCheck(this, ToggleFeature);

      return _possibleConstructorReturn(this, _getPrototypeOf(ToggleFeature).apply(this, arguments));
    }

    _createClass(ToggleFeature, [{
      key: "render",
      value: function render() {
        if (this.props.isFeatureEnabled) {
          if (this.props.toggledComponent) return React__default.createElement(this.props.toggledComponent);
          if (this.props.children && !isEmptyChildren(this.props.children)) return React__default.Children.only(this.props.children);
          if (typeof this.props.render === 'function') return this.props.render();
        }

        if (typeof this.props.children === 'function') return this.props.children({
          isFeatureEnabled: this.props.isFeatureEnabled
        });

        if (this.props.untoggledComponent) {
          return React__default.createElement(this.props.untoggledComponent);
        }

        return null;
      }
    }]);

    return ToggleFeature;
  }(React.PureComponent);

  ToggleFeature.displayName = 'ToggleFeature';
  ToggleFeature.defaultProps = {
    untoggledComponent: null,
    toggledComponent: null,
    render: null,
    children: null
  };
  ToggleFeature.propTypes = {
    untoggledComponent: function untoggledComponent(props, propName) {
      if (props[propName] && !reactIs.isValidElementType(props[propName])) {
        return new Error("Invalid prop 'untoggledComponent' supplied to 'Route': the prop is not a valid React component");
      }
    },
    toggledComponent: function toggledComponent(props, propName) {
      if (props[propName] && !reactIs.isValidElementType(props[propName])) {
        return new Error("Invalid prop 'toggledComponent' supplied to 'Route': the prop is not a valid React component");
      }
    },
    render: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
  };

  var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
    var previousDisplayName = BaseComponent.displayName || BaseComponent.name;
    return "".concat(hocName, "(").concat(previousDisplayName || 'Component', ")");
  };

  var setDisplayName = function setDisplayName(nextDisplayName) {
    return function (BaseComponent) {
      BaseComponent['displayName'] = nextDisplayName;
      return BaseComponent;
    };
  };

  var omitProps = function omitProps() {
    for (var _len = arguments.length, propsToOmit = new Array(_len), _key = 0; _key < _len; _key++) {
      propsToOmit[_key] = arguments[_key];
    }

    return function (BaseComponent) {
      var OmitProps = function OmitProps(props) {
        return React.createElement(BaseComponent, omit(props, propsToOmit));
      };

      {
        return setDisplayName(wrapDisplayName(BaseComponent, 'omitProps'))(OmitProps);
      }
      return OmitProps;
    };
  };

  var withProps = function withProps(mapProps) {
    return function (BaseComponent) {
      var WithProps = function WithProps(ownProps) {
        var enhancedProps = typeof mapProps === 'function' ? _objectSpread({}, ownProps, mapProps(ownProps)) : _objectSpread({}, ownProps, mapProps);
        return React.createElement(BaseComponent, enhancedProps);
      };

      {
        return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(WithProps);
      }
      return WithProps;
    };
  };

  var DEFAULT_FLAG_PROP_KEY = 'isFeatureEnabled';
  var DEFAULT_FLAGS_PROP_KEY = 'featureToggles';
  var ALL_FLAGS_PROP_KEY = '@flopflip/flags';

  var injectFeatureToggle = function injectFeatureToggle(flagName) {
    var propKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLAG_PROP_KEY;
    return flowRight(withProps(function (ownProps) {
      var flagValue = ownProps[ALL_FLAGS_PROP_KEY][flagName];
      return _defineProperty({}, propKey, isNil(flagValue) ? false : flagValue);
    }), omitProps(ALL_FLAGS_PROP_KEY));
  };

  var filterFeatureToggles = function filterFeatureToggles(allFlags, demandedFlags) {
    return intersection(Object.keys(allFlags), demandedFlags).reduce(function (featureToggles, featureToggle) {
      return _objectSpread({}, featureToggles, _defineProperty({}, featureToggle, allFlags[featureToggle]));
    }, {});
  };

  var injectFeatureToggles = function injectFeatureToggles(flagNames) {
    var propKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLAGS_PROP_KEY;
    var areOwnPropsEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : areOwnPropsEqual;
    return flowRight(withProps(function (props) {
      return _defineProperty({}, propKey, filterFeatureToggles(props[ALL_FLAGS_PROP_KEY], flagNames));
    }), omitProps(ALL_FLAGS_PROP_KEY), function (BaseComponent) {
      var _class, _temp;

      return _temp = _class =
      /*#__PURE__*/
      function (_Component) {
        _inherits(ShouldUpdate, _Component);

        function ShouldUpdate() {
          _classCallCheck(this, ShouldUpdate);

          return _possibleConstructorReturn(this, _getPrototypeOf(ShouldUpdate).apply(this, arguments));
        }

        _createClass(ShouldUpdate, [{
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(nextProps) {
            return typeof areOwnPropsEqual === 'function' ? !areOwnPropsEqual(this.props, nextProps, propKey) : true;
          }
        }, {
          key: "render",
          value: function render() {
            return React__default.createElement(BaseComponent, this.props);
          }
        }]);

        return ShouldUpdate;
      }(React.Component), _class.displayName = BaseComponent.displayName, _temp;
    });
  };
  /**
   * Given a `flagName` and a `flagVariation`
   * indicating if the given feature should be toggled (turned off).
   *
   * @method isFeatureEnabled
   * @param  {String}    flagName                   The flag name (e.g. signup-v2)
   * @param  {Boolean}   [flagVariation=true]       The variation of the flag defaulting to `true`
   * @return {Boolean}                              Indicator if the flag should be toggled
   */


  var isFeatureEnabled = function isFeatureEnabled() {
    var flagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FLAG_PROP_KEY;
    var flagVariation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    warning(flagName === camelCase(flagName), '@flopflip/react: passed flag name does not seem to be normalized which may result in unexpected toggling. Please refer to our readme for more information: https://github.com/tdeekens/flopflip#flag-normalization');
    return function (flags) {
      return flags[flagName] === flagVariation;
    };
  };

  var DefaultUntoggledComponent =
  /*#__PURE__*/
  function (_Component) {
    _inherits(DefaultUntoggledComponent, _Component);

    function DefaultUntoggledComponent() {
      _classCallCheck(this, DefaultUntoggledComponent);

      return _possibleConstructorReturn(this, _getPrototypeOf(DefaultUntoggledComponent).apply(this, arguments));
    }

    _createClass(DefaultUntoggledComponent, [{
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return DefaultUntoggledComponent;
  }(React.Component);

  var branchOnFeatureToggle = function branchOnFeatureToggle() {
    var UntoggledComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultUntoggledComponent;
    var flagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FLAG_PROP_KEY;
    var flagVariation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return function (ToggledComponent) {
      var BranchOnFeatureToggle = function BranchOnFeatureToggle(props) {
        if (isFeatureEnabled(flagName, flagVariation)(props)) {
          return React.createElement(ToggledComponent, props);
        } else {
          return React.createElement(UntoggledComponent, props);
        }
      };

      return BranchOnFeatureToggle;
    };
  };

  var AdapterContext = createReactContext(function () {});
  var AdapterStates = {
    UNCONFIGURED: 'unconfigured',
    CONFIGURING: 'configuring',
    CONFIGURED: 'configured'
  };

  var isEmptyChildren$1 = function isEmptyChildren(children) {
    return React__default.Children.count(children) === 0;
  };

  var mergeAdapterArgs = function mergeAdapterArgs(previousAdapterArgs, _ref) {
    var nextAdapterArgs = _ref.adapterArgs,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? {} : _ref$options;
    return options.shouldOverwrite ? nextAdapterArgs : merge(previousAdapterArgs, nextAdapterArgs);
  };

  var ConfigureAdapter =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ConfigureAdapter, _PureComponent);

    function ConfigureAdapter() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, ConfigureAdapter);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ConfigureAdapter)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.adapterState = AdapterStates.UNCONFIGURED;
      _this.pendingAdapterArgs = null;
      _this.state = {
        appliedAdapterArgs: _this.props.adapterArgs
      };

      _this.setAdapterState = function (nextAdapterState) {
        _this.adapterState = nextAdapterState;
      };

      _this.applyAdapterArgs = function (nextAdapterArgs
      /**
       * NOTE:
       *   We can only unset `pendingAdapterArgs` after be actually perform
       *   a batched `setState` otherwise outdated `adapterArgs` as we loose
       *   the `pendingAdapterArgs` as we unset them too early.
       */
      ) {
        return _this.setState(function (prevState) {
          return _objectSpread({}, prevState, {
            appliedAdapterArgs: nextAdapterArgs
          });
        }, function () {
          _this.pendingAdapterArgs = null;
        });
      };

      _this.reconfigureOrQueue = function (nextAdapterArgs, options) {
        return _this.adapterState === AdapterStates.CONFIGURED && _this.adapterState !== AdapterStates.CONFIGURING ? _this.applyAdapterArgs(mergeAdapterArgs(_this.state.appliedAdapterArgs, {
          adapterArgs: nextAdapterArgs,
          options: options
        })) : _this.setPendingAdapterArgs({
          adapterArgs: nextAdapterArgs,
          options: options
        });
      };

      _this.setPendingAdapterArgs = function (nextReconfiguration) {
        /**
         * NOTE:
         *    The next reconfiguration is merged into the previous
         *    one instead of maintaining a queue.
         *
         *    The first merge with merge with `appliedAdapter` args
         *    to contain the initial state (through property initializer).
         */
        _this.pendingAdapterArgs = mergeAdapterArgs(_this.pendingAdapterArgs || _this.state.appliedAdapterArgs, nextReconfiguration);
      };

      _this.getAdapterArgsForConfiguration = function () {
        return _this.pendingAdapterArgs || _this.state.appliedAdapterArgs;
      };

      _this.handleDefaultFlags = function (defaultFlags) {
        if (Object.keys(defaultFlags).length > 0) {
          _this.props.adapterArgs.onFlagsStateChange(defaultFlags);
        }
      };

      return _this;
    }

    _createClass(ConfigureAdapter, [{
      key: "componentWillReceiveProps",

      /**
       * NOTE:
       *   This should be UNSAFE_componentWillReceiveProps.
       *   However to maintain compatibility with older and newer versions of React
       *   this can not be prefixed with UNSAFE_.
       *
       *   For the future this should likely happen in cDU however as `reconfigureOrQueue`
       *   may trigger a `setState` it might have unexpected side-effects (setState-loop).
       *   Maybe some more substancial refactor would be needed.
       */
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.adapterArgs !== this.props.adapterArgs) {
          /**
           * NOTE:
           *   The component might receive `adapterArgs` from `ReconfigureFlopflip`
           *   before it managed to configure. If that occurs the next `adapterArgs`
           *   passed in will overwrite what `ReconfigureFlopflip` passed in before
           *   yieling a loss in configuration.
           *
           *   Whenever however the adapter has configured we want to component to
           *   act in a controleld manner. So that overwriting will occur when the
           *   passed `adapterArgs` change.
           */
          this.reconfigureOrQueue(nextProps.adapterArgs, {
            shouldOverwrite: this.adapterState === AdapterStates.CONFIGURED
          });
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.handleDefaultFlags(this.props.defaultFlags);

        if (!this.props.shouldDeferAdapterConfiguration) {
          this.setAdapterState(AdapterStates.CONFIGURING);
          return this.props.adapter.configure(this.getAdapterArgsForConfiguration()).then(function () {
            _this2.setAdapterState(AdapterStates.CONFIGURED);

            if (_this2.pendingAdapterArgs) {
              _this2.applyAdapterArgs(_this2.pendingAdapterArgs);
            }
          });
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this3 = this;
        /**
         * NOTE:
         *    Be careful here to not double configure from `componentDidMount`.
         *    Moreover, cDU will also be invoked from `setState` to `appliedAdapterArgs`.
         *    Hence, avoid calling `setState` within cDU.
         */


        if (!this.props.shouldDeferAdapterConfiguration && this.adapterState !== AdapterStates.CONFIGURED && this.adapterState !== AdapterStates.CONFIGURING) {
          this.setAdapterState(AdapterStates.CONFIGURING);
          return this.props.adapter // NOTE: ESLint otherwise fails for unknown reasons
          // eslint-disable-next-line
          .configure(this.getAdapterArgsForConfiguration()).then(function () {
            _this3.setAdapterState(AdapterStates.CONFIGURED);

            if (_this3.pendingAdapterArgs) {
              _this3.applyAdapterArgs(_this3.pendingAdapterArgs);
            }
          });
        } else if (this.adapterState === AdapterStates.CONFIGURED && this.adapterState !== AdapterStates.CONFIGURING) {
          this.setAdapterState(AdapterStates.CONFIGURING);
          return this.props.adapter // NOTE: ESLint otherwise fails for unknown reasons
          // eslint-disable-next-line
          .reconfigure(this.getAdapterArgsForConfiguration()).then(function () {
            _this3.setAdapterState(AdapterStates.CONFIGURED);
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        return React__default.createElement(AdapterContext.Provider, {
          value: this.reconfigureOrQueue
        }, function () {
          var isAdapterReady = _this4.props.adapter.getIsReady();

          if (isAdapterReady) {
            if (typeof _this4.props.render === 'function') return _this4.props.render();
          }

          if (typeof _this4.props.children === 'function') return _this4.props.children({
            isAdapterReady: isAdapterReady
          });
          if (_this4.props.children && !isEmptyChildren$1(_this4.props.children)) return React__default.Children.only(_this4.props.children);
        }());
      }
    }]);

    return ConfigureAdapter;
  }(React.PureComponent);

  ConfigureAdapter.defaultProps = {
    shouldDeferAdapterConfiguration: false,
    defaultFlags: {},
    children: null,
    render: null
  };
  ConfigureAdapter.propTypes = {
    shouldDeferAdapterConfiguration: PropTypes.bool,
    defaultFlags: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    adapter: PropTypes.shape({
      configure: PropTypes.func.isRequired,
      reconfigure: PropTypes.func.isRequired,
      getIsReady: PropTypes.func.isRequired
    }).isRequired,
    render: PropTypes.func
  };

  var withReconfiguration = function withReconfiguration() {
    var propKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'reconfigure';
    return function (Component$$1) {
      var EnhancedComponent =
      /*#__PURE__*/
      function (_PureComponent) {
        _inherits(EnhancedComponent, _PureComponent);

        function EnhancedComponent() {
          _classCallCheck(this, EnhancedComponent);

          return _possibleConstructorReturn(this, _getPrototypeOf(EnhancedComponent).apply(this, arguments));
        }

        _createClass(EnhancedComponent, [{
          key: "render",
          value: function render() {
            var _this = this;

            return React__default.createElement(AdapterContext.Consumer, null, function (reconfigure) {
              return React__default.createElement(Component$$1, Object.assign({}, _this.props, _defineProperty({}, propKey, reconfigure)));
            });
          }
        }]);

        return EnhancedComponent;
      }(React.PureComponent);

      EnhancedComponent.displayName = "withReconfiguration(".concat(Component$$1.displayName || Component$$1.name || 'Component', ")");
      return EnhancedComponent;
    };
  };

  var ReconfigureAdapter =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(ReconfigureAdapter, _PureComponent);

    function ReconfigureAdapter() {
      _classCallCheck(this, ReconfigureAdapter);

      return _possibleConstructorReturn(this, _getPrototypeOf(ReconfigureAdapter).apply(this, arguments));
    }

    _createClass(ReconfigureAdapter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        return this.props.reconfigure({
          user: this.props.user
        }, {
          shouldOverwrite: this.props.shouldOverwrite
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        return this.props.reconfigure({
          user: this.props.user
        }, {
          shouldOverwrite: this.props.shouldOverwrite
        });
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children ? React__default.Children.only(this.props.children) : null;
      }
    }]);

    return ReconfigureAdapter;
  }(React.PureComponent);

  ReconfigureAdapter.displayName = 'ReconfigureAdapter';
  ReconfigureAdapter.defaultProps = {
    shouldOverwrite: false,
    children: null
  };
  ReconfigureAdapter.propTypes = {
    shouldOverwrite: PropTypes.bool,
    children: PropTypes.node
  };
  var reconfigureAdapter = withReconfiguration()(ReconfigureAdapter);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
      isFeatureEnabled: isFeatureEnabled(ownProps.flag, ownProps.variation)(state[STATE_SLICE].flags)
    };
  };
  /* istanbul ignore next */

  var toggleFeature = flowRight(setDisplayName(ToggleFeature.displayName), reactRedux.connect(mapStateToProps))(ToggleFeature);

  var mapStateToProps$1 = function mapStateToProps(state) {
    return _defineProperty({}, ALL_FLAGS_PROP_KEY, selectFlags(state));
  };
  var injectFeatureToggle$1 = (function (flagName, propKey) {
    return function (WrappedComponent
    /* istanbul ignore next */
    ) {
      return flowRight(setDisplayName(wrapDisplayName(WrappedComponent, 'injectFeatureToggle')), reactRedux.connect(mapStateToProps$1), injectFeatureToggle(flagName, propKey))(WrappedComponent);
    };
  });

  var mapStateToProps$2 = function mapStateToProps(state) {
    return _defineProperty({}, ALL_FLAGS_PROP_KEY, selectFlags(state));
  };
  var injectFeatureToggles$1 = (function (flagNames, propKey, areOwnPropsEqual) {
    return function (WrappedComponent
    /* istanbul ignore next */
    ) {
      return flowRight(setDisplayName(wrapDisplayName(WrappedComponent, 'injectFeatureToggles')), reactRedux.connect(mapStateToProps$2), injectFeatureToggles(flagNames, propKey, areOwnPropsEqual))(WrappedComponent);
    };
  });

  var branchOnFeatureToggle$1 = (function (_ref, UntoggledComponent) {
    var flag = _ref.flag,
        variation = _ref.variation;
    return function (WrappedComponent) {
      return flowRight(setDisplayName(wrapDisplayName(WrappedComponent, 'branchOnFeatureToggle')), injectFeatureToggle$1(flag), branchOnFeatureToggle(UntoggledComponent, DEFAULT_FLAG_PROP_KEY, variation))(WrappedComponent);
    };
  });

  /**
   * NOTE:
   *    This function can not be memoized otherwise it will
   *    rewrire different `ConfigureFlopflip`s to the same change
   *    handlers as these functions seem to be referentially equal even
   *    across different instances of React components due to hoisting.
   */
  var createAdapterArgs = function createAdapterArgs(adapterArgs, handleUpdateStatus, handleUpdateFlags) {
    return _objectSpread({}, adapterArgs, {
      onStatusStateChange: handleUpdateStatus,
      onFlagsStateChange: handleUpdateFlags
    });
  };

  var Configure =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Configure, _PureComponent);

    function Configure() {
      _classCallCheck(this, Configure);

      return _possibleConstructorReturn(this, _getPrototypeOf(Configure).apply(this, arguments));
    }

    _createClass(Configure, [{
      key: "render",
      value: function render() {
        return React__default.createElement(ConfigureAdapter, {
          adapter: this.props.adapter,
          adapterArgs: createAdapterArgs(this.props.adapterArgs, this.props.handleUpdateStatus, this.props.handleUpdateFlags),
          defaultFlags: this.props.defaultFlags,
          shouldDeferAdapterConfiguration: this.props.shouldDeferAdapterConfiguration
        }, this.props.children ? React__default.Children.only(this.props.children) : null);
      }
    }]);

    return Configure;
  }(React.PureComponent);
  Configure.displayName = 'ConfigureFlopflip';
  Configure.defaultProps = {
    children: null,
    defaultFlags: {},
    shouldDeferAdapterConfiguration: false
  };
  Configure.propTypes = {
    children: PropTypes.element,
    defaultFlags: PropTypes.object,
    shouldDeferAdapterConfiguration: PropTypes.bool
  };
  var mapDispatchToProps = {
    handleUpdateStatus: updateStatus,
    handleUpdateFlags: updateFlags
  };
  /* istanbul ignore next */

  var configure = reactRedux.connect(null, mapDispatchToProps)(Configure);

  var version$1 = "7.1.9";

  exports.createFlopFlipEnhancer = createFlopFlipEnhancer;
  exports.FLOPFLIP_STATE_SLICE = STATE_SLICE;
  exports.createFlopflipReducer = createFlopflipReducer;
  exports.flopflipReducer = flopflipReducer;
  exports.selectFeatureFlags = selectFlags;
  exports.selectFeatureFlag = selectFlag;
  exports.UPDATE_STATUS = UPDATE_STATUS;
  exports.UPDATE_FLAGS = UPDATE_FLAGS;
  exports.ToggleFeature = toggleFeature;
  exports.injectFeatureToggle = injectFeatureToggle$1;
  exports.injectFeatureToggles = injectFeatureToggles$1;
  exports.branchOnFeatureToggle = branchOnFeatureToggle$1;
  exports.ConfigureFlopFlip = configure;
  exports.ReconfigureFlopFlip = reconfigureAdapter;
  exports.version = version$1;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=@flopflip-react-redux.umd.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@flopflip/react-redux/dist/@flopflip-react-redux.umd.js
// module id = 107
// module chunks = 1